import { useQuery } from 'react-query';

import auth from '@udacity/ureact-hoth';

import { useClientRender } from '~/hooks/use-client-render';

import { getUserPreferences } from '../controllers/get-user-preferences';

export function useUserPreferences() {
  const isClient = useClientRender();
  const jwt = isClient ? auth.getJWT() : undefined;
  const isAuthenticated = Boolean(jwt);

  const { data, isLoading, isFetched } = useQuery('userPreferences', () => getUserPreferences({ jwt: jwt! }), {
    enabled: isAuthenticated,
  });

  return {
    userPreferences: data,
    isLoading: isAuthenticated && isLoading,
    isFetched,
  };
}
